import React from 'react';
import { PageHeader, SectionCard, StatusPill, EmptyState } from '@/components/portal/PortalUI';
import { Button } from '@shared/components/ui/button';
import { Upload, FileCheck } from 'lucide-react';

const PortalCredentials = () => {
  const credentials = [
    {
      name: 'Medical Self-Certificate',
      status: 'Pending review',
      expiry: '—',
    },
    {
      name: 'CSCS / ECS',
      status: 'Required',
      expiry: '—',
    },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Credentials"
        subtitle="Upload certificates and track verification status."
        actions={<Button size="sm">Upload document</Button>}
      />

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <SectionCard title="Upload centre" subtitle="Accepted formats: PDF, JPG, PNG" className="lg:col-span-2">
          <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border bg-muted/40 px-6 py-10 text-center">
            <Upload className="h-8 w-8 text-muted-foreground" />
            <p className="text-sm font-medium text-foreground">Drop files here or browse</p>
            <p className="text-xs text-muted-foreground">Files will be linked to your credential record.</p>
            <Button variant="outline" size="sm">Browse files</Button>
          </div>
        </SectionCard>

        <SectionCard title="Verification status" subtitle="Live once portal APIs are connected">
          <div className="space-y-3">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Verified</span>
              <span className="font-semibold">0</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Pending</span>
              <span className="font-semibold">2</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Required</span>
              <span className="font-semibold">1</span>
            </div>
          </div>
        </SectionCard>
      </div>

      {credentials.length ? (
        <SectionCard title="Required credentials">
          <div className="space-y-3">
            {credentials.map((credential) => (
              <div key={credential.name} className="flex flex-col gap-3 rounded-lg border border-border/60 bg-muted/40 p-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-3">
                  <FileCheck className="h-5 w-5 text-primary" />
                  <div>
                    <p className="text-sm font-semibold text-foreground">{credential.name}</p>
                    <p className="text-xs text-muted-foreground">Expiry: {credential.expiry}</p>
                  </div>
                </div>
                <StatusPill tone={credential.status === 'Required' ? 'danger' : 'warning'} label={credential.status} />
              </div>
            ))}
          </div>
        </SectionCard>
      ) : (
        <EmptyState
          title="No credentials assigned"
          description="Credentials will appear here once your portal profile is linked."
        />
      )}
    </div>
  );
};

export default PortalCredentials;
